import { AxiosError } from 'axios';

export type ExtractByType<T, S> = Pick<T, {
    [K in keyof T]: T[K] extends S ? K : never
}[keyof T]>;

export interface IBaseAction {
    type: string;
}

export interface IAction<Payload> extends IBaseAction {
    payload: Payload;
    error?: boolean;
}

export interface IObjectSignature {
    object_id: number;
    layer_code: string;
}

export * from './operations';
export * from './app';
export * from './pkk';
